var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrancheta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4893 34.179L19.9799 30.6696L18.0693 32.5801L23.4893 38L34.3291 27.1602L32.4186 25.2496L23.4893 34.179Z",
    fill: "#0F2554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5542 4.12549H23.4893V2.77051C23.4871 2.05244 23.2009 1.3644 22.6932 0.856645C22.1854 0.348893 21.4974 0.0626914 20.7793 0.0605469H9.93945C9.22139 0.0626914 8.53334 0.348893 8.02559 0.856645C7.51784 1.3644 7.23164 2.05244 7.22949 2.77051V4.12549H3.16455C2.44648 4.12763 1.75844 4.41383 1.25069 4.92159C0.742936 5.42934 0.456734 6.11738 0.45459 6.83545V35.29C0.456734 36.0081 0.742936 36.6961 1.25069 37.2039C1.75844 37.7116 2.44648 37.9978 3.16455 38H15.3594V35.29H3.16455V6.83545H7.22949V10.9004H23.4893V6.83545H27.5542V21.7402H30.2642V6.83545C30.262 6.11738 29.9758 5.42934 29.4681 4.92159C28.9603 4.41383 28.2723 4.12763 27.5542 4.12549ZM20.7793 8.19043H9.93945V2.77051H20.7793V8.19043Z",
    fill: "#0F2554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrancheta);
export default __webpack_public_path__ + "static/media/prancheta.abde405e7ad847acaa9da0d11c6837c8.svg";
export { ForwardRef as ReactComponent };